import * as React from 'react';
export const IcLineCrossing = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 17h-4.51a43.381 43.381 0 00-3-4.35V9.8A10 10 0 0017 11a1 1 0 000-2 9 9 0 01-4.88-1.78.53.53 0 00-.1-.06.82.82 0 00-.19-.09h-.37a.65.65 0 00-.2 0 .51.51 0 00-.13 0 11.94 11.94 0 00-5 4.38 1 1 0 00.28 1.38A.94.94 0 007 13a1 1 0 00.83-.45 11.141 11.141 0 012.67-2.8v3.19A10 10 0 018.93 17H4a1 1 0 000 2h2.74c-.065.033-.129.07-.19.11A1 1 0 007 21a.93.93 0 00.45-.11A8.13 8.13 0 009.9 19h4.44c.26.46.52.95.77 1.45A1 1 0 0016 21a.93.93 0 00.45-.11 1 1 0 00.44-1.34c-.09-.18-.18-.37-.28-.55H20a1 1 0 000-2zm-8.73 0c.288-.55.532-1.122.73-1.71.35.49.74 1.06 1.15 1.71h-1.88z'
      fill='currentColor'
    />
  </svg>
);
